module.exports = __webpack_public_path__ + "img/roundRightArrow.9638060b.svg";